import * as React from 'react';

import { useSlug } from '../hooks/useSlug';
import { GlobalProps } from '../types';
import { classes } from '../utils';

import styles from './styles.module.css';

export type FormProps = GlobalProps & {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  noValidate?: boolean;
  name?: string;
  alignDirection?: 'start' | 'center' | 'stretch';
  autoComplete?: 'on' | 'off';
  children?: React.ReactNode;
  layout?: 'default' | 'tight' | 'loose';
};

// forwardRef strangely has reversed generic signature from parameters
export const Form = React.forwardRef<HTMLFormElement, FormProps>(
  function FormComponent(props, ref) {
    const {
      children,
      onSubmit,
      noValidate = false,
      name,
      layout = 'default',
      autoComplete = 'on',
      alignDirection = 'start',
    } = props;

    const slugName = useSlug(name || '');

    const cx = classes(
      [styles.form, styles[alignDirection], styles[layout]],
      props
    );

    return (
      <form
        className={cx}
        onSubmit={onSubmit}
        noValidate={noValidate}
        data-component={slugName}
        name={name}
        autoComplete={autoComplete}
        ref={ref}
      >
        {children}
      </form>
    );
  }
);
